import {createRouter, createWebHistory, RouteRecordRaw} from 'vue-router'
import {UserRole} from "@/models/enum/UserRole";
import Login from "@/apps/public/pages/Login.vue";
import Dashboard from "@/apps/public/pages/Dashboard.vue";
import Settings from "@/apps/public/pages/Settings.vue";
import Requisites from "@/apps/public/pages/Requisites.vue";
import Deals from "@/apps/public/pages/Deals.vue";
import Statistics from "@/apps/public/pages/Statistics.vue";
import Disputes from "@/apps/public/pages/Disputes.vue";
import TraderOperators from "@/apps/public/pages/TraderOperators.vue";
import InviteLogin from "@/apps/public/pages/InviteLogin.vue";

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'dashboard',
        component: Dashboard,
        meta: {requiresAuth: true, roles: [UserRole.TRADER, UserRole.TRADER_OPERATOR, UserRole.MERCHANT, UserRole.MERCHANT]},
    },
    {
        path: '/deals',
        name: 'deals',
        component: Deals,
        meta: {requiresAuth: true, roles: [UserRole.TRADER, UserRole.TRADER_OPERATOR]},
    },
    {
        path: '/disputes',
        name: 'disputes',
        component: Disputes,
        meta: {requiresAuth: true, roles: [UserRole.TRADER, UserRole.TRADER_OPERATOR]},
    },
    {
        path: '/statistics',
        name: 'statistic',
        component: Statistics,
        meta: {requiresAuth: true, roles: [UserRole.TRADER, UserRole.TRADER_OPERATOR, UserRole.MERCHANT, UserRole.MERCHANT]},
    },
    {
        path: '/trader-operators',
        name: 'traderOperators',
        component: TraderOperators,
        meta: {requiresAuth: true, roles: [UserRole.TRADER]},
    },
    {
        path: '/requisites',
        name: 'requisites',
        component: Requisites,
        meta: {requiresAuth: true, roles: [UserRole.TRADER, UserRole.TRADER_OPERATOR]},
    },
    {
        path: '/settings',
        name: 'settings',
        component: Settings,
        meta: {requiresAuth: true, roles: [UserRole.TRADER, UserRole.TRADER_OPERATOR, UserRole.MERCHANT, UserRole.MERCHANT]},
    },
    {path: '/login', name: 'login', component: Login},
    {path: '/invite/:token', name: 'inviteLogin', component: InviteLogin},
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router

